import { mapImageConstants } from '../utils/imageMapper';
import servicesData from '../data/servicesData.json';

export interface Service {
  title: string;
  description: string;
  color: string;
}

export interface Testimonial {
  text: string;
  author: string;
  role: string;
}

export interface CardPosition {
  top: string;
  right: string;
  width: string;
  zIndex: number;
}

export interface ServicesData {
  heroSection: {
    title: string;
    description: string;
    image: string;
    glowEffect: string;
  };
  ourServices: {
    title: string;
    subtitle: string;
    services: Service[];
  };
  techBusiness: {
    title: string;
    description: string[];
    image: string;
    imageAlt: string;
  };
  ideasSection: {
    title: string;
    subtitle: string;
    ctaTitle: string;
    ctaButtonText: string;
    testimonials: Testimonial[];
    cardPositions: CardPosition[];
  };
}

export function useServicesData() {
  const data = mapImageConstants(servicesData as ServicesData);
  const loading = false;
  const error = null;

  return { data, loading, error };
}
